import { Observable } from 'rxjs'
import { errorAction } from '~/redux/commonActions'
import {
  actionTypes,
  addRelatedItemSuccess,
  updateRelatedItemSuccess,
} from '../draftEditor'
import ArcUUID from '~/util/arc-identifiers'
import converterFactory from '~/reactapp/story/converterFactory'
import { Map } from 'immutable'
import get from 'lodash/get'
import CONSTANTS from '~/constants'

const relatedItemUrls = {
  story: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/search`,
  image: '/photo/selector/?select=multiple',
  gallery: '/photo/galleries/selector/?select=multiple',
  video: '/videocenter/plugins/videosearch/',
}

const makeMapFromANS = (ans) => {
  const contentState = converterFactory
    .toDraftContent([ans])
    .get('contentState')

  return {
    key: ArcUUID.create(),
    clipboardANS: new Map(ans),
    contentState,
    customStyleMap: Map(),
  }
}

export const makeRelatedContentMapFromANS = (ansArray) => {
  const draftFormatted = ansArray.map((ansData) => makeMapFromANS(ansData))

  const mappedByType = draftFormatted.reduce((acc, item) => {
    const type = item.clipboardANS.get('type')
    acc[type] = acc[type] || []
    acc[type].push(new Map(item))
    return acc
  }, {})

  return mappedByType
}

export default (action$, store, { serviceResolver }) =>
  action$
    .ofType(actionTypes.ACTION_ADD_RELATED_ITEM)
    .mergeMap((action) => {
      const thirdPartyIntegrationService = serviceResolver(
        'thirdPartyIntegrationService'
      )
      let promise
      if (action.payload.type === 'custom_embed') {
        promise = new Promise((resolve) => resolve(action.payload.ansData))
      } else {
        promise = thirdPartyIntegrationService(
          relatedItemUrls[action.payload.type]
        )
      }

      const foundEmbed = get(
        store.getState(),
        'draftEditor.relatedContent.data.custom_embed',
        []
      ).find(
        (embed) =>
          embed.getIn(['clipboardANS', '_id']) ===
          get(action.payload.ansData, '_id', '')
      )

      // Handle EDIT for custom_embed
      if (foundEmbed) {
        return Observable.from(promise)
          .filter((something) => {
            return !!something
          })
          .map((ans) =>
            updateRelatedItemSuccess({
              key: 'custom_embed', // only type that edits its own data for now
              data: new Map(makeMapFromANS(ans)),
            })
          )
      } else {
        return Observable.from(promise)
          .filter((something) => {
            return !!something
          })
          .map((ansOrArray) =>
            Array.isArray(ansOrArray) ? ansOrArray : [ansOrArray]
          )
          .map((ansArray) => {
            const relatedContentMap = makeRelatedContentMapFromANS(ansArray)
            return addRelatedItemSuccess(relatedContentMap)
          })
          .catch((error) => {
            // Cancelling thirdPartyIntegrationService reject promise and causing
            // error to be undefined.
            return Observable.of(error && errorAction(error))
          })
      }
    })
    .filter((action) => !!action)
